import styled from 'styled-components';

export const Frame = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  background: ${({ theme }) => theme.colors.surfaceContainer};
`;

export const FrameImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const GenerateRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
`;

export const Note = styled.span`
  ${({ theme }) => theme.font.bodySmall};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;

export const CoverRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const SWATCH_PX = 32;

export const CoverChoice = styled.button<{ $selected: boolean }>`
  flex: none;
  width: ${SWATCH_PX}px;
  height: ${SWATCH_PX}px;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: transparent;
  border: 2px solid ${({ $selected, theme }) => ($selected ? theme.colors.primary : 'transparent')};

  &:disabled {
    cursor: progress;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const CoverImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
